const TEMPLATE_NAME = 'VISIT_PAGE';

const initialState = () => ({
    completedVisitsActiveTab: 0,
    plannedVisitsActiveTab: 0,
    completedVisitsLoading: false,
    plannedVisitsLoading: false,
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_COMPLETED_VISITS_CHANGE_TAB`: {
            const activeIndex = action.payload;
            return {
                ...state,
                completedVisitsActiveTab: activeIndex,
                completedVisitsLoading: true,
            };
        }
        case `${TEMPLATE_NAME}_COMPLETED_VISITS_FULFILLED`: {
            return {
                ...state,
                completedVisitsLoading: false,
            };
        }
        case `${TEMPLATE_NAME}_COMPLETED_VISITS_REJECTED`: {
            return {
                ...state,
                completedVisitsLoading: false,
            };
        }
        case `${TEMPLATE_NAME}_PLANNED_VISITS_CHANGE_TAB`: {
            const activeIndex = action.payload;
            return {
                ...state,
                plannedVisitsActiveTab: activeIndex,
                plannedVisitsLoading: true,
            };
        }
        case `${TEMPLATE_NAME}_PLANNED_VISITS_FULFILLED`: {
            return {
                ...state,
                plannedVisitsLoading: false,
            };
        }
        case `${TEMPLATE_NAME}_PLANNED_VISITS_REJECTED`: {
            return {
                ...state,
                plannedVisitsLoading: true,
            };
        }
        default:
            return state;
    }
};
export default reducer;